module.exports = __webpack_public_path__ + "static/media/lockscreen-bg.0d7ef366.jpg";